export const getTransferActivityTableHeaderRules = (
  id: string,
  sortBy: string
) => ({ id, sortBy, align: "right", isSortable: true });
